var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.previewClass},[_c('div',{staticClass:"viewer-container",attrs:{"id":"pdf-ui"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }